import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import { resolveRichText } from "../../../utils/richText";
import * as styles from "./TimeLinePanel.module.scss";


const TimeLinePanel = ({ blok }) => {

  return (
    <PanelWrapper blok={blok}>
      <Container>
        <Row>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_1)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_2)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_3)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_4)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_5)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
              <hr className={styles.line + " " + styles.ln_right} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_6)}
            ></div>
          </Col>
          <Col className={styles.time_blok} xs={12} sm={6} md={4} lg={true}>
            <div className={styles.line_container}>
              <hr className={styles.line + " " + styles.ln_left} />
            </div>
            <div
              dangerouslySetInnerHTML={resolveRichText(blok.time_blok_7)}
            ></div>
          </Col>
        </Row>
      </Container>
    </PanelWrapper>
  );
};

export default TimeLinePanel;
